import {useGetCurrentUserQuery, useGetTenantDataQuery} from './api';

const useUserOwner = () => {
  const {data: tenant} = useGetTenantDataQuery();
  const {data: user} = useGetCurrentUserQuery();

  return tenant?.contacts?.email === user?.login;
};

export {useUserOwner};
